export const HRWideCardData = {
    card1up1: "24 LPA",
    card1up3: 'leftover increased by 5%',
    card1dnP: "COMPANY BUDGET LEFTOVER",
}
export const CRMWideCardData = {
    card1up1: "70",
    card1up3: 'increased by 10% since last year',
    card1dnP: "TARGET FOR THIS YEAR",
}